import { Skeleton } from '@mui/material';

const DetailedJobViewSkeleton = () => {
  return (
    <div style={{ padding: '1.25rem' }}>
      <Skeleton variant='text' />
      <Skeleton
        variant='text'
        style={{
          marginTop: '0.9375rem',
          marginBottom: '0.9375rem',
        }}
      />
      <div
        style={{
          padding: '0.9375rem',
          border: '0.0625rem solid #cac4d0',
          paddingRight: '9.375rem',
          borderRadius: '0rem',
          width: '37.5rem',
        }}
      >
        <Skeleton variant='text' style={{ marginBottom: '0.75rem' }} />
        <Skeleton variant='text' style={{ marginBottom: '0.75rem' }} />
        <Skeleton variant='text' style={{ marginBottom: '0.75rem' }} />
        <Skeleton variant='text' style={{ marginBottom: '0.75rem' }} />
        <Skeleton variant='text' style={{ marginBottom: '0.75rem' }} />
        <Skeleton variant='text' style={{ marginBottom: '0.75rem' }} />
        <Skeleton variant='text' style={{ marginBottom: '0.75rem' }} />
        <Skeleton variant='text' style={{ marginBottom: '0.75rem' }} />
        <Skeleton variant='text' style={{ marginBottom: '0.75rem' }} />
        <Skeleton variant='text' style={{ marginBottom: '0.75rem' }} />
      </div>
      <Skeleton
        variant='text'
        style={{
          marginTop: '0.9375rem',
          marginBottom: '0.9375rem',
        }}
      />
      <div
        style={{
          padding: '0.9375rem',
          border: '0.0625rem solid #cac4d0',
          paddingRight: '9.375rem',
          borderRadius: '0rem',
          width: '40.625rem',
        }}
      >
        <Skeleton variant='text' style={{ marginBottom: '0.75rem' }} />
        <Skeleton variant='text' style={{ marginBottom: '0.75rem' }} />
        <Skeleton variant='text' style={{ marginBottom: '0.75rem' }} />
        <Skeleton variant='text' style={{ marginBottom: '0.75rem' }} />
        <Skeleton variant='text' style={{ marginBottom: '0.75rem' }} />
        <Skeleton variant='text' style={{ marginBottom: '0.75rem' }} />
      </div>
    </div>
  );
};

export default DetailedJobViewSkeleton;
